import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";



import Header from "./components/Header";
import Footer from "./components/Footer";
import NotFound from "./components/NotFound";

import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Faq from "./pages/Faq";
import Login from "./pages/Login";
import Register from "./pages/Register";
import CompanyReviews from "./pages/CompanyReviews";
import JobList from "./pages/JobList";
import CareerAdvice from "./pages/CareerAdvice";
import Help from "./pages/Help";
import Salary from "./pages/Salary";

// 👉 Import AuthProvider
import { AuthProvider } from "./context/AuthContext";

const App = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  return (
    <AuthProvider>
      <div className={isDarkMode ? "dark-theme" : "light-theme"}>
        <Header isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />

        <div className="container mt-4 mb-5">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/companyreviews" element={<CompanyReviews />} />
            <Route path="/jobs" element={<JobList />} />
            <Route path="/careeradvice" element={<CareerAdvice />} />
            <Route path="/help" element={<Help />} />
            <Route path="/salary" element={<Salary />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>

        <Footer />
      </div>
    </AuthProvider>
  );
};

export default App;
